var XMLHttpRequest = window.XMLHttpRequest

window.Http = {
  makeRequest: function (method, url, data, success, error) {
    var reqData = ''
    if (data && method != 'GET') { reqData = JSON.stringify(data) }
    if (data && method == 'GET') { reqData = data }
    $.ajax({
      url: url,
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      method: method,
      data: reqData,
      success: function (res) {
        if (success) success(res)
      },
      error: function (res) {
        if (error) error(res)
      }
    })
  },

  get: function (url, data, success, error) {
    this.makeRequest('GET', url, data, success, error)
  },

  post: function (url, data, success, error) {
    this.makeRequest('POST', url, data, success, error)
  },

  postWithFile: function (url, data, success, error) {
    var xhr = new XMLHttpRequest()
    xhr.open('POST', url)
    xhr.setRequestHeader('Accept', '*/*')
    xhr.setRequestHeader('X-CSRF-Token', document.querySelector('meta[name="csrf-token"]').content)
    xhr.send(data)
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        try {
          var res = JSON.parse(xhr.response, true)
          if (res.status < 300) {
            success(res)
          } else {
            error(res)
          }
        } catch (err) {
          error(err)
        }
      }
    }
  },

  put: function (url, data, success, error) {
    this.makeRequest('PUT', url, data, success, error)
  },

  delete: function (url, data, success, error) {
    this.makeRequest('DELETE', url, data, success, error)
  }
}
